// keys for assets loaded from the game config theme

export const AssetKey = {
  GameLogo: 'game-logo',
  // Backgrounds

  HomeBg: 'home-bg',
  GameBg: 'main-background',
  FinishBg: 'finish-bg',

  // Node textures
  NodeUpcoming: 'node-upcoming', // Neutral node - not yet visited
  NodeCompleted: 'node-completed', // Neutral node - visited or active
  NodeActionUpcoming: 'node-action-upcoming', // Action node - not yet visited
  NodeActionCompleted: 'node-action-completed', // Action node - visited or active
} as const;
